// extracted by mini-css-extract-plugin
export default {"step_text_shadow":"getStarted_step_text_shadow__rM+ID"};